<schir-int-client-spinner [diameter]="20" [stateResource]="korrespondenzVorlage">

	@if (korrespondenzVorlage.loaded) {
		<schir-int-client-more-button data-test-id="more-button">

			@if ((korrespondenzVorlage.resource | hasResourceLink: korrespondenzVorlageLinkRel.UPLOAD_FILE)) {
				<schir-int-client-file-upload #button

		                              (fileChanged)="upload.emit($event)">
			<a #fileUploadButton mat-mini-fab color="primary" [matTooltipPosition]="'right'"
			   matTooltip="Korrespondenzvorlage hochladen und ersetzen"
			   aria-label="Korrespondenzvorlage hochladen und ersetzen"
			   data-test-id="upload-korrespondenz-button">
				<i class="material-icons" aria-hidden="true">cloud_upload</i>
			</a>
		</schir-int-client-file-upload>
			}

			@if ((korrespondenzVorlage.resource | hasResourceLink: korrespondenzVorlageLinkRel.DELETE)) {
				<schir-int-client-button-round #button
				cssClass="focus-inwards-dark  schir-midi-button" (click)="delete.emit()"
				data-test-id="delete-korrespondenz-button" toolTip="Korrespondenzvorlage entfernen"
				                               toolTipPosition="right" materialIcon="remove"/>
			}
	</schir-int-client-more-button>
	}
</schir-int-client-spinner>
